import React, { useState } from "react";
import { setMyPin, getStaffProfile } from "../services/api";

// Staff set their own 4-char quick-switch code (for shared tablets).
export default function MyCodePage() {
  const [pin, setPin] = useState("");
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const me = getStaffProfile();

  const submit = async (e) => {
    e.preventDefault();
    setMsg(""); setErr("");
    if (!/^[A-Z0-9]{4}$/.test(pin)) { setErr("Code must be exactly 4 letters or numbers."); return; }
    setBusy(true);
    try {
      await setMyPin(pin);
      setMsg("Your quick code is set. Use it to start your shift fast on a shared tablet.");
      setPin("");
    } catch (e2) {
      setErr(e2?.response?.data?.detail || "Could not save the code.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <h1>My quick code</h1>
      <p className="muted" style={{ maxWidth: 540 }}>
        Set a 4-character code (letters and numbers). On a shared tablet you can tap it to start your
        shift instantly — no email or password needed.{me?.name ? ` Signed in as ${me.name}.` : ""}
      </p>
      <form onSubmit={submit} className="card" style={{ maxWidth: 380, marginTop: 12 }}>
        <label style={{ fontSize: 13, fontWeight: 600 }}>New code</label>
        <input
          value={pin}
          onChange={(e) => setPin(e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 4))}
          maxLength={4}
          placeholder="e.g. K7P2"
          aria-label="New quick code"
          style={{ display: "block", width: "100%", boxSizing: "border-box", fontSize: 24, letterSpacing: 8, textAlign: "center", padding: "10px", marginTop: 6, borderRadius: 8, border: "1px solid #cdd8e3", textTransform: "uppercase", fontWeight: 700 }}
        />
        {err && <div className="error" style={{ marginTop: 10 }}>{err}</div>}
        {msg && <div style={{ marginTop: 10, color: "#1D9E75", fontWeight: 600 }}>{msg}</div>}
        <button className="btn" type="submit" disabled={busy} style={{ marginTop: 14 }}>
          {busy ? "Saving…" : "Save code"}
        </button>
      </form>
    </>
  );
}
